import React, { useState } from 'react';
 import uttrakhandlogo from '../Images/uttrakhandlogo.png';
 import urdalogo from '../Images/urdalogo.png';
// import { useSelector } from "react-redux";

const Header = () => {

  const handleLogout = () => {
    // Add your logout logic here
    console.log("User logged out");
  };

  return (
    <>
    <div className="bg-white p-0 border-b border-[#F34303] flex justify-between items-center">
      {/* Left side */}
      <div className="flex items-center space-x-4 ml-5 my-4">
        <div className="flex items-center">
        <img
          src={uttrakhandlogo} // Replace this with your desired image path
          alt="Profile Icon"
          className="w-16 h-16 rounded-full mr-3 cursor-pointer"
          
        />
        <div className='flex-col text-[#241C68]'>
          <h1 className="text-sm font-bold md:text-2xl mr-2">UTTRAKHAND RURAL ROAD</h1>
          <h1 className="border-b border-[#F34303] text-sm font-bold md:text-2xl">DEVELOPMENT AGENCY</h1>
          <h3 className="text-xs md:text-lg">Govt. Of Uttrakhand</h3>
        </div>
        </div>
      </div>

      {/* Right side - Role Text */}
      <div className="relative flex items-center mr-7">
        <img
          src={urdalogo} // Replace this with your desired image path
          alt="Profile Icon"
          className="w-16 h-16 rounded-full mr-3 cursor-pointer"
        
        />
        <div>
          <h3 className="text-xl font-bold text-[#F34303]">PMGSY</h3>
         
        </div>


      </div>
    
    </div>
             
           
              </>
  );
};

export default Header;
